var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "boss-main-wrap boss-main-content-wrap" },
    [
      _c("setting-header", {
        attrs: {
          breadcrumbs: [
            { name: "社員からの評判", pathName: "realIntentionTop" },
          ],
          title: "社員からの評判＿" + _vm.title,
          "data-test": "title-real-intention",
        },
      }),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "cell-auto" },
        [
          _c("form-label", {
            attrs: { label: "性別" },
            scopedSlots: _vm._u([
              {
                key: "body",
                fn: function () {
                  return [
                    _c(
                      "div",
                      _vm._l(_vm.genders, function (option) {
                        return _c(
                          "label",
                          {
                            key: option.id,
                            staticClass:
                              "align-center margin-right-1 pega-input pega-realintention-radio-area",
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.realIntention.gender,
                                  expression: "realIntention.gender",
                                },
                              ],
                              staticClass: "boss-input-checkbox",
                              attrs: {
                                "data-test": "gender-" + option.id,
                                name: "gender",
                                type: "radio",
                              },
                              domProps: {
                                value: { id: option.id, name: option.name },
                                checked:
                                  _vm.realIntention.gender.id === option.id,
                                checked: _vm._q(_vm.realIntention.gender, {
                                  id: option.id,
                                  name: option.name,
                                }),
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.$set(_vm.realIntention, "gender", {
                                    id: option.id,
                                    name: option.name,
                                  })
                                },
                              },
                            }),
                            _vm._v(_vm._s(option.name) + "\n          "),
                          ]
                        )
                      }),
                      0
                    ),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
          _vm._v(" "),
          _c("form-item-number", {
            attrs: {
              placeholder: "半角数字のみ",
              "max-number": 99,
              "min-number": 1,
              errors: [_vm.ageValidation],
              "data-test": "age",
              "form-label-class-name": "medium-3,cell pega-form-label",
              "class-name": "pega-realintention-number-area",
            },
            scopedSlots: _vm._u([
              {
                key: "label",
                fn: function () {
                  return [
                    _c("label", [
                      _vm._v("\n          年齢"),
                      _c("br"),
                      _vm._v(" "),
                      _c("small", [_vm._v("（半角数字のみ）")]),
                    ]),
                  ]
                },
                proxy: true,
              },
              {
                key: "suffix",
                fn: function () {
                  return [_c("span", [_vm._v("歳")])]
                },
                proxy: true,
              },
            ]),
            model: {
              value: _vm.realIntention.age,
              callback: function ($$v) {
                _vm.$set(_vm.realIntention, "age", $$v)
              },
              expression: "realIntention.age",
            },
          }),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("form-item", {
                attrs: {
                  "class-name": _vm.postValidation.isShow
                    ? "is-invalid-input"
                    : "",
                  "data-test": "post",
                },
                scopedSlots: _vm._u([
                  {
                    key: "label",
                    fn: function () {
                      return [
                        _vm._v("\n          所属部署・職種"),
                        _c("br"),
                        _vm._v(" "),
                        _c("small", [_vm._v("（200文字以内）")]),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "header",
                    fn: function () {
                      return [
                        _c("small", [
                          _vm._v(
                            _vm._s(_vm.realIntention.post.length) +
                              "文字／" +
                              _vm._s(_vm.post_max) +
                              "文字"
                          ),
                        ]),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "error",
                    fn: function () {
                      return [
                        _vm.postValidation.isShow
                          ? _c("validation-label", {
                              attrs: {
                                "data-test": "post-error",
                                label: _vm.postValidation.message,
                              },
                            })
                          : _vm._e(),
                      ]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.realIntention.post,
                  callback: function ($$v) {
                    _vm.$set(_vm.realIntention, "post", $$v)
                  },
                  expression: "realIntention.post",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("form-label", {
            attrs: { label: "キャリア" },
            scopedSlots: _vm._u([
              {
                key: "body",
                fn: function () {
                  return [
                    _c(
                      "div",
                      _vm._l(
                        _vm.realIntentionOptions.career,
                        function (option) {
                          return _c(
                            "label",
                            {
                              key: option.id,
                              staticClass:
                                "align-center margin-right-1 pega-input pega-realintention-radio-area",
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.realIntention.career,
                                    expression: "realIntention.career",
                                  },
                                ],
                                staticClass: "boss-input-checkbox",
                                attrs: {
                                  "data-test": "career-" + option.id,
                                  name: "career",
                                  type: "radio",
                                },
                                domProps: {
                                  value: { id: option.id, name: option.name },
                                  checked:
                                    _vm.realIntention.career.id === option.id,
                                  checked: _vm._q(_vm.realIntention.career, {
                                    id: option.id,
                                    name: option.name,
                                  }),
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$set(
                                      _vm.realIntention,
                                      "career",
                                      { id: option.id, name: option.name }
                                    )
                                  },
                                },
                              }),
                              _vm._v(_vm._s(option.name) + "\n          "),
                            ]
                          )
                        }
                      ),
                      0
                    ),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
          _vm._v(" "),
          _c("form-item-number", {
            attrs: {
              placeholder: "半角数字のみ",
              "max-number": 99,
              "min-number": 1,
              errors: [_vm.serviceYearValidation],
              "data-test": "service-year",
              "form-label-class-name": "medium-3,cell pega-form-label",
              "class-name": "pega-realintention-number-area",
            },
            scopedSlots: _vm._u([
              {
                key: "label",
                fn: function () {
                  return [
                    _c("label", [
                      _vm._v("\n          入社年数"),
                      _c("br"),
                      _vm._v(" "),
                      _c("small", [_vm._v("（半角数字のみ）")]),
                    ]),
                  ]
                },
                proxy: true,
              },
              {
                key: "suffix",
                fn: function () {
                  return [_c("span", [_vm._v("年目")])]
                },
                proxy: true,
              },
            ]),
            model: {
              value: _vm.realIntention.serviceYear,
              callback: function ($$v) {
                _vm.$set(_vm.realIntention, "serviceYear", $$v)
              },
              expression: "realIntention.serviceYear",
            },
          }),
          _vm._v(" "),
          _c("form-label", {
            attrs: { label: "アイコン" },
            scopedSlots: _vm._u([
              {
                key: "body",
                fn: function () {
                  return [
                    _c(
                      "div",
                      { staticClass: "pega-icon-area-wrap" },
                      _vm._l(
                        _vm.realIntentionOptions.iconNames,
                        function (name) {
                          return _c(
                            "label",
                            {
                              key: name,
                              staticClass: "pega-icon-area pega-input",
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src:
                                    _vm.userRealIntentionImageUrlForPc +
                                    "/" +
                                    name,
                                  "data-test": "icon-url-" + name,
                                },
                              }),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.realIntention.icon,
                                    expression: "realIntention.icon",
                                  },
                                ],
                                staticClass: "align-center boss-input-checkbox",
                                attrs: {
                                  "data-test": "icon-" + name,
                                  name: "icon",
                                  type: "radio",
                                },
                                domProps: {
                                  value: name,
                                  checked: _vm.realIntention.icon === name,
                                  checked: _vm._q(_vm.realIntention.icon, name),
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$set(
                                      _vm.realIntention,
                                      "icon",
                                      name
                                    )
                                  },
                                },
                              }),
                            ]
                          )
                        }
                      ),
                      0
                    ),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "cell-auto" },
        [
          _c("form-item-text-area", {
            attrs: {
              type: "textarea",
              "class-name": _vm.question1Validation.isShow
                ? "pega-realintention-textarea is-invalid-input"
                : "pega-realintention-textarea",
              "data-test": "question1",
            },
            scopedSlots: _vm._u([
              {
                key: "label",
                fn: function () {
                  return [
                    _c("span", [
                      _vm._v(
                        "\n          Q1.あなたの会社はどんな会社だと思う？"
                      ),
                      _c("br"),
                      _vm._v(" "),
                      _c("small", [_vm._v("（500文字以内）")]),
                    ]),
                  ]
                },
                proxy: true,
              },
              {
                key: "header",
                fn: function () {
                  return [
                    _c("div", [
                      _c("small", [
                        _vm._v(
                          _vm._s(_vm.realIntention.question1.length) +
                            "文字/" +
                            _vm._s(_vm.question_max) +
                            "文字"
                        ),
                      ]),
                    ]),
                  ]
                },
                proxy: true,
              },
              {
                key: "error",
                fn: function () {
                  return [
                    _vm.question1Validation.isShow
                      ? _c("validation-label", {
                          attrs: {
                            "data-test": "question1-error",
                            label: _vm.question1Validation.message,
                          },
                        })
                      : _vm._e(),
                  ]
                },
                proxy: true,
              },
            ]),
            model: {
              value: _vm.realIntention.question1,
              callback: function ($$v) {
                _vm.$set(_vm.realIntention, "question1", $$v)
              },
              expression: "realIntention.question1",
            },
          }),
          _vm._v(" "),
          _c("form-item-text-area", {
            attrs: {
              type: "textarea",
              "class-name": _vm.question2Validation.isShow
                ? "pega-realintention-textarea is-invalid-input"
                : "pega-realintention-textarea",
              "data-test": "question2",
            },
            scopedSlots: _vm._u([
              {
                key: "label",
                fn: function () {
                  return [
                    _c("span", [
                      _vm._v("\n          Q2.会社の一番良いところは？"),
                      _c("br"),
                      _vm._v(" "),
                      _c("small", [_vm._v("（500文字以内）")]),
                    ]),
                  ]
                },
                proxy: true,
              },
              {
                key: "header",
                fn: function () {
                  return [
                    _c("div", [
                      _c("small", [
                        _vm._v(
                          _vm._s(_vm.realIntention.question2.length) +
                            "文字/" +
                            _vm._s(_vm.question_max) +
                            "文字"
                        ),
                      ]),
                    ]),
                  ]
                },
                proxy: true,
              },
              {
                key: "error",
                fn: function () {
                  return [
                    _vm.question2Validation.isShow
                      ? _c("validation-label", {
                          attrs: {
                            "data-test": "question2-error",
                            label: _vm.question2Validation.message,
                          },
                        })
                      : _vm._e(),
                  ]
                },
                proxy: true,
              },
            ]),
            model: {
              value: _vm.realIntention.question2,
              callback: function ($$v) {
                _vm.$set(_vm.realIntention, "question2", $$v)
              },
              expression: "realIntention.question2",
            },
          }),
          _vm._v(" "),
          _c("form-item-text-area", {
            attrs: {
              "class-name": _vm.question3Validation.isShow
                ? "pega-realintention-textarea is-invalid-input"
                : "pega-realintention-textarea",
              "data-test": "question3",
            },
            scopedSlots: _vm._u([
              {
                key: "label",
                fn: function () {
                  return [
                    _c("span", [
                      _vm._v("\n          Q3.会社に期待していることは？"),
                      _c("br"),
                      _vm._v(" "),
                      _c("small", [_vm._v("（500文字以内）")]),
                    ]),
                  ]
                },
                proxy: true,
              },
              {
                key: "header",
                fn: function () {
                  return [
                    _c("div", [
                      _c("small", [
                        _vm._v(
                          _vm._s(_vm.realIntention.question3.length) +
                            "文字/" +
                            _vm._s(_vm.question_max) +
                            "文字"
                        ),
                      ]),
                    ]),
                  ]
                },
                proxy: true,
              },
              {
                key: "error",
                fn: function () {
                  return [
                    _vm.question3Validation.isShow
                      ? _c("validation-label", {
                          attrs: {
                            "data-test": "question3-error",
                            label: _vm.question3Validation.message,
                          },
                        })
                      : _vm._e(),
                  ]
                },
                proxy: true,
              },
            ]),
            model: {
              value: _vm.realIntention.question3,
              callback: function ($$v) {
                _vm.$set(_vm.realIntention, "question3", $$v)
              },
              expression: "realIntention.question3",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm._m(2),
      _vm._v(" "),
      _c(
        "form-button-area",
        [
          _c("form-confirm-button", {
            attrs: {
              "is-disabled": _vm.hasErrors,
              "submit-label": "登録内容を確認する",
              "data-test": "confirm-button",
            },
            on: { "submit-event": _vm.onRegisterClick },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "margin-top-1" }, [
      _c("h3", { staticClass: "boss-joboffer-title boss-setting" }, [
        _vm._v("\n      回答者データ\n    "),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "margin-top-2" }, [
      _c("h3", { staticClass: "boss-joboffer-title boss-setting" }, [
        _vm._v("\n      質問内容\n    "),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "margin-top-1 text-center font-bold" }, [
      _c("span", [
        _c("small", { attrs: { "data-test": "all-required-alert" } }, [
          _vm._v("全て必須項目です。入力漏れにご注意ください。"),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }